// removed by extract-text-webpack-plugin
module.exports = {"btn":"_1rRd8kVBNJ82sP14h-jVhM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisLinkLikeButton.scss
// module id = 1077
// module chunks = 0